import { Field } from "./field";
import { MerchantError, MerchantFieldMapper } from "./types";

export type FieldErrorMap = MerchantFieldMapper<MerchantError>;

type FieldErrorType =
  | "FieldMismatch"
  | "InvalidCompanyNumber"
  | "InvalidEmail"
  | "InvalidDate"
  | "InvalidLength"
  | "InvalidPhone"
  | "InvalidTypeNumber"
  | "InvalidWebsite"
  | "InvalidFormat"
  | "Required";

export class FieldError extends Error {
  constructor(
    public field: Field<any>,
    error: string,
    public errorType: FieldErrorType
  ) {
    super(error);
  }
}

interface MerchantValidationDefaults {
  locationsLength?: number;
  ownersLength?: number;
}
/*
 * Aggregate Error
 */
export class MerchantValidationError extends Error {
  public fieldErrorMap: FieldErrorMap;

  constructor(opts?: MerchantValidationDefaults) {
    super();
    const { locationsLength = 1, ownersLength = 5 } = opts || {};

    this.fieldErrorMap = {
      cashPay: {},
      companyInformation: {},
      customerSupport: {},
      lead: {},
      locations: Array.from({ length: locationsLength }, () => ({})),
      owners: Array.from({ length: ownersLength }, () => ({})),
      primaryBank: {},
      secondaryBank: {},
      storeDetails: {},
    };
  }
}
